import type {StateCreator} from 'zustand'
import type {PullRequestFileTreeDiff} from '../../page-data/payloads/file-tree'

// I ALMOST want to call this the diff map, or something different
export type DiffSummariesSlice = {
  diffSummaries?: PullRequestFileTreeDiff[]
  setDiffSummaries: (diffSummaries?: PullRequestFileTreeDiff[]) => void
}

export const createDiffSummariesSlice =
  (): StateCreator<DiffSummariesSlice, [['zustand/devtools', never]], [], DiffSummariesSlice> => (set, _get) => ({
    codeowners: undefined,
    setDiffSummaries: (diffSummaries?: PullRequestFileTreeDiff[]) => {
      set({diffSummaries}, undefined, 'updateDiffSummaries')
    },
  })
